module.exports = __webpack_public_path__ + "media/metronic/_theme/media/users/300_17-14bc6dfed87b20210469b4042fee9aa6.jpg";